import { BackgroundImage, Box, Container, Dialog, Flex, Link, Text } from 'pcln-design-system'
import React from 'react'

const _MoreInfoWithModal = (props) => {
  const { onClose, isOpen, ...rest } = props
  return isOpen ? (
    <Dialog
      ariaTitle='More info modal'
      ariaDescription={`Info Modal - More info modal`}
      open={isOpen}
      onOpenChange={onClose}
      {...rest}
    >
      <_MoreInfo {...rest} />
    </Dialog>
  ) : null
}

const _MoreInfo = (props) => {
  const { heading, primaryMedia, body, disclaimer, primaryCallToAction, secondaryCallToAction } = props

  return (
    <Container>
      {primaryMedia?.url && (
        <BackgroundImage
          alt={primaryMedia.altText}
          image={primaryMedia.url}
          height={250}
          data-testid='primary-media'
        />
      )}
      <Flex flexDirection='column' m={[3, null, null, 4]}>
        {heading && (
          <Text textStyle='heading3' mb={3} mt={0}>
            {heading}
          </Text>
        )}
        {body && <Box mb={3}>{body}</Box>}
        {(primaryCallToAction || secondaryCallToAction) && (
          <Flex my={3} flexDirection={['column-reverse', 'row']} data-testid='link-container'>
            {primaryCallToAction && (
              <Link
                mr={[0, 2]}
                variation='fill'
                mb={0}
                href={primaryCallToAction.longUrl || primaryCallToAction.url}
              >
                {primaryCallToAction.label}
              </Link>
            )}
            {secondaryCallToAction && (
              <Link
                mb={[2, 0, null]}
                variation='outline'
                href={secondaryCallToAction.longUrl || secondaryCallToAction.url}
              >
                {secondaryCallToAction.label}
              </Link>
            )}
          </Flex>
        )}
        {disclaimer && (
          <Text fontSize={11} fontWeight={500} mb={0} color='text.light'>
            {disclaimer}
          </Text>
        )}
      </Flex>
    </Container>
  )
}

const MoreInfo = (props) => {
  const { withModal } = props
  return withModal ? <_MoreInfoWithModal {...props} /> : <_MoreInfo {...props} />
}

export default MoreInfo
